<template>
 <section class="breadcrumb__area box-plr-75">
      <div class="container">
          <div class="row">
              <div class="col-xxl-12">
                  <div class="breadcrumb__wrapper">
                      <nav aria-label="breadcrumb">
                          <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link href="/">Home</router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">Shop</li>
                          </ol>
                        </nav>
                  </div>
              </div>
          </div>
      </div>
  </section>
</template>

<script>

</script>
